var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComprehension(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "comprehension") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5, 0.5)",
    fill: "none",
    stroke: "currentColor",
    className: "nc-icon-wrapper"
  }, /*#__PURE__*/React.createElement("line", {
    strokeWidth: 3,
    strokeLinecap: "round",
    x1: 2,
    y1: 32,
    x2: 8,
    y2: 32,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 3,
    strokeLinecap: "round",
    x1: 10.787,
    y1: 10.787,
    x2: 15.029,
    y2: 15.029,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 3,
    strokeLinecap: "round",
    x1: 32,
    y1: 2,
    x2: 32,
    y2: 8,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 3,
    strokeLinecap: "round",
    x1: 53.213,
    y1: 10.787,
    x2: 48.971,
    y2: 15.029,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 3,
    strokeLinecap: "round",
    x1: 62,
    y1: 32,
    x2: 56,
    y2: 32,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 3,
    strokeLinecap: "round",
    x1: 25,
    y1: 62,
    x2: 39,
    y2: 62,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 3,
    strokeLinecap: "round",
    d: "M49,32 c0-9.389-7.611-17-17-17s-17,7.611-17,17c0,6.891,4.107,12.81,10,15.48V56h14v-8.52C44.893,44.81,49,38.891,49,32z",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComprehension);
export default __webpack_public_path__ + "static/media/comprehension.44a6a044f3aadd035e9410b1092fdd93.svg";
export { ForwardRef as ReactComponent };